<template>
  <div class="container">
    <div class="title">
      <el-breadcrumb>
        <el-breadcrumb-item>业务管理</el-breadcrumb-item>
        <el-breadcrumb-item>工单审计</el-breadcrumb-item>
        <el-breadcrumb-item>DCOPS审计</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="title-en">查询条件</div>
    <el-card class="box-card audit-search-card">
      <el-tabs v-model="activeAuditTab" class="audit-tabs" @tab-click="onAuditTabClick">
        <el-tab-pane label="主动审计" name="active">
          <div class="search-container">
            <el-form :inline="true" :model="searchFormActive" class="search-form" label-width="100px">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="创建时间">
                    <el-date-picker
                      v-model="searchFormActive.createdRange"
                      type="daterange"
                      range-separator="-"
                      style="width: 100%"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="工单号">
                    <el-input v-model="searchFormActive.op_ticketid" placeholder="请输入工单号" clearable />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="待办工单号">
                    <el-input v-model="searchFormActive.main_ticket_id" placeholder="JSON 内 mainTicketId" clearable />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="审计结果">
                    <el-select
                      v-model="searchFormActive.audit_result"
                      clearable
                      placeholder="全部"
                      style="width: 100%"
                    >
                      <el-option label="通过" value="通过" />
                      <el-option label="不通过" value="不通过" />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="场景">
                    <el-input v-model="searchFormActive.scene" placeholder="如：网络运营 / 服务器运营" clearable />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="工单类型">
                    <el-input v-model="searchFormActive.ticket_type" placeholder="模糊查询" clearable />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="机房">
                    <el-input v-model="searchFormActive.auditinfo_idcp_name" placeholder="一级机房" clearable />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="状态">
                    <el-select
                      v-model="searchFormActive.process_status"
                      clearable
                      placeholder="全部"
                      style="width: 100%"
                    >
                      <el-option label="运行中" value="running" />
                      <el-option label="结束" value="finished" />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20" class="search-actions-row">
                <el-col :span="24">
                  <div class="search-button">
                    <el-button type="primary" @click="handleSearch">点击查询</el-button>
                    <el-button @click="handleResetActive">重置</el-button>
                    <el-button :loading="exportLoading" @click="debouncedExport">{{ exportButtonText }}</el-button>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane label="被动审计" name="passive">
          <div class="search-container">
            <el-form :inline="true" :model="searchFormPassive" class="search-form" label-width="100px">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="创建时间">
                    <el-date-picker
                      v-model="searchFormPassive.createdRange"
                      type="daterange"
                      range-separator="-"
                      style="width: 100%"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="工单号">
                    <el-input v-model="searchFormPassive.op_ticketid" placeholder="请输入工单号" clearable />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="待办工单号">
                    <el-input v-model="searchFormPassive.main_ticket_id" placeholder="JSON 内 mainTicketId" clearable />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="审计结果">
                    <el-select
                      v-model="searchFormPassive.audit_result"
                      clearable
                      placeholder="全部"
                      style="width: 100%"
                    >
                      <el-option label="通过" value="通过" />
                      <el-option label="不通过" value="不通过" />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="复核结果">
                    <el-select
                      v-model="searchFormPassive.review_result"
                      clearable
                      placeholder="全部"
                      style="width: 100%"
                    >
                      <el-option label="复核无误" value="复核无误" />
                      <el-option label="申诉" value="申诉" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="最终结果">
                    <el-select
                      v-model="searchFormPassive.final_result"
                      clearable
                      placeholder="全部"
                      style="width: 100%"
                    >
                      <el-option label="通过" value="通过" />
                      <el-option label="不通过" value="不通过" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="审计机房">
                    <el-input v-model="searchFormPassive.audit_result_idcp_name" placeholder="一级机房" clearable />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="状态">
                    <el-select
                      v-model="searchFormPassive.process_status"
                      clearable
                      placeholder="全部"
                      style="width: 100%"
                    >
                      <el-option label="运行中" value="running" />
                      <el-option label="结束" value="finished" />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20" class="search-actions-row">
                <el-col :span="24">
                  <div class="search-button">
                    <el-button type="primary" @click="handleSearch">点击查询</el-button>
                    <el-button @click="handleResetPassive">重置</el-button>
                    <el-button :loading="exportLoading" @click="debouncedExport">{{ exportButtonText }}</el-button>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <div class="title-en">{{ tableTitle }}</div>
    <el-card class="box-card">
      <div class="table-container">
        <div class="button-container">
          <el-button @click="openColumnsDialog">表头设置</el-button>
        </div>

        <el-table :data="rows" border stripe v-loading="loading" ref="table">
          <el-table-column
            v-for="(column, index) in visibleColumns"
            :key="column.prop + '-' + index"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="column.prop === 'opTicketid'">
                <a
                  :href="dcopsDetailHref(scope.row.opTicketid)"
                  target="_blank"
                  rel="noopener noreferrer"
                >{{ scope.row.opTicketid }}</a>
              </span>
              <span v-else-if="column.prop === 'main_ticket_display'">{{ mainTicketDisplay(scope.row) }}</span>
              <span v-else-if="isJsonColumn(column.prop)" class="json-cell-wrap">
                <el-button type="text" size="small" class="json-view-btn" @click="openJsonDetail(scope.row, column.prop)">
                  查看详情
                </el-button>
                <span class="json-cell-summary">{{ jsonCellSummary(scope.row[column.prop], column.prop) }}</span>
              </span>
              <span v-else-if="column.prop === 'audit_result'">
                <span v-if="isPendingAuditEmpty(scope.row.audit_result)" class="audit-pending">审计中...</span>
                <el-tag v-else :type="resultTagType('audit', scope.row.audit_result)" size="small" effect="plain">
                  <i :class="['result-ico', resultTagIcon('audit', scope.row.audit_result)]" />
                  {{ scope.row.audit_result }}
                </el-tag>
              </span>
              <span v-else-if="column.prop === 'review_result'">
                <template v-if="isEmptyCell(scope.row.review_result)">-</template>
                <el-tag v-else :type="resultTagType('review', scope.row.review_result)" size="small" effect="plain">
                  <i :class="['result-ico', resultTagIcon('review', scope.row.review_result)]" />
                  {{ scope.row.review_result }}
                </el-tag>
              </span>
              <span v-else-if="column.prop === 'finalResult'">
                <el-tag
                  v-if="!isPendingAuditEmpty(scope.row.finalResult)"
                  :type="resultTagType('final', scope.row.finalResult)"
                  size="small"
                  effect="plain"
                >
                  <i :class="['result-ico', resultTagIcon('final', scope.row.finalResult)]" />
                  {{ scope.row.finalResult }}
                </el-tag>
                <span
                  v-else-if="!isPendingAuditEmpty(scope.row.review_result)"
                  class="audit-pending"
                >复核中</span>
              </span>
              <span v-else-if="column.prop === 'created_at' || column.prop === 'updated_at'">{{
                formatTime(scope.row[column.prop])
              }}</span>
              <span v-else>{{ cellText(scope.row[column.prop]) }}</span>
            </template>
          </el-table-column>
        </el-table>

        <!-- JSON 结构化详情（对照 auditInfo / ctrlPoint / auditResult / reviewFile） -->
        <el-dialog
          :title="jsonDetailTitle"
          :visible.sync="jsonDetailVisible"
          append-to-body
          width="960px"
          top="6vh"
          custom-class="json-detail-dialog"
          :close-on-click-modal="false"
          @closed="onJsonDetailClosed"
        >
          <div class="json-detail-body">
            <template v-if="jsonDetailMode === 'review_file'">
              <div v-if="!jsonDetailRows.length" class="json-empty">暂无附件</div>
              <ul v-else class="review-file-list">
                <li v-for="(f, idx) in jsonDetailRows" :key="idx" class="review-file-item">
                  <i
                    :class="[
                      'el-file-icon',
                      isImageUrl(fileUrl(f)) ? 'el-icon-picture-outline' : 'el-icon-document',
                    ]"
                  />
                  <a :href="fileUrl(f)" target="_blank" rel="noopener noreferrer" class="file-name">{{
                    fileDisplayName(f)
                  }}</a>
                  <div v-if="isImageUrl(fileUrl(f))" class="img-preview-wrap">
                    <img :src="fileUrl(f)" alt="" class="thumb" @error="onImgError" />
                  </div>
                </li>
              </ul>
            </template>

            <template v-else-if="jsonDetailMode === 'audit_info'">
              <el-table v-if="jsonDetailRows.length" :data="jsonDetailRows" border stripe size="small" max-height="520">
                <el-table-column prop="mainTicketId" label="待办工单号" min-width="130" show-overflow-tooltip />
                <el-table-column prop="idcpName" label="一级机房" min-width="140" show-overflow-tooltip />
                <el-table-column prop="completer" label="业务结单人" min-width="100" show-overflow-tooltip />
                <el-table-column prop="ticketType" label="工单类型" min-width="120" show-overflow-tooltip />
                <el-table-column prop="auditService" label="审计服务商" min-width="100" show-overflow-tooltip />
                <el-table-column prop="auditedService" label="被审计服务商" min-width="110" show-overflow-tooltip />
                <el-table-column prop="memo" label="备注" min-width="120" show-overflow-tooltip />
                <el-table-column label="工单链接" min-width="160">
                  <template slot-scope="s">
                    <a v-if="s.row.ticketURL" :href="s.row.ticketURL" target="_blank" rel="noopener noreferrer">打开</a>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
              </el-table>
              <div v-else class="json-empty">暂无数据</div>
            </template>

            <template v-else-if="jsonDetailMode === 'ctrl_point_info'">
              <el-table v-if="jsonDetailRows.length" :data="jsonDetailRows" border stripe size="small" max-height="520">
                <el-table-column prop="ctrlContent" label="管控内容" min-width="220" show-overflow-tooltip />
                <el-table-column prop="ctrlStandard" label="管控标准" min-width="220" show-overflow-tooltip />
              </el-table>
              <div v-else class="json-empty">暂无数据</div>
            </template>

            <template v-else-if="jsonDetailMode === 'audit_result_info'">
              <el-table v-if="jsonDetailRows.length" :data="jsonDetailRows" border stripe size="small" max-height="520">
                <el-table-column prop="mainTicketId" label="待办工单号" min-width="120" show-overflow-tooltip />
                <el-table-column prop="scene" label="业务场景" min-width="100" show-overflow-tooltip />
                <el-table-column prop="ticketType" label="工单类型" min-width="120" show-overflow-tooltip />
                <el-table-column label="工单链接" min-width="100">
                  <template slot-scope="s">
                    <a v-if="s.row.ticketURL" :href="s.row.ticketURL" target="_blank" rel="noopener noreferrer">打开</a>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column prop="ctrlStandard" label="管控标准" min-width="140" show-overflow-tooltip />
                <el-table-column prop="ctrlContent" label="管控内容" min-width="160" show-overflow-tooltip />
                <el-table-column label="管控点审计结果" min-width="140" align="center">
                  <template slot-scope="s">
                    <template v-if="isEmptyCell(s.row.ctrlAuditResult)">-</template>
                    <el-tag v-else :type="resultTagType('ctrl', s.row.ctrlAuditResult)" size="small" effect="plain">
                      <i :class="['result-ico', resultTagIcon('ctrl', s.row.ctrlAuditResult)]" />
                      {{ s.row.ctrlAuditResult }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="ctrlAuditMemo" label="管控点审计备注" min-width="160" show-overflow-tooltip />
              </el-table>
              <div v-else class="json-empty">暂无数据</div>
            </template>

            <template v-else-if="jsonDetailMode === 'raw'">
              <pre class="json-raw">{{ jsonDetailRawText }}</pre>
            </template>
          </div>
        </el-dialog>

        <el-dialog
          title="设置显示项"
          :visible.sync="showColumnsDialog"
          :append-to-body="true"
          width="560px"
          :close-on-click-modal="false"
          :destroy-on-close="true"
        >
          <el-checkbox-group v-model="selectedColumns" class="checkbox-group">
            <el-checkbox v-for="column in columns" :key="column.prop" :label="column.prop" class="checkbox-item">
              {{ column.label }}
            </el-checkbox>
          </el-checkbox-group>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="selectAllColumns">全选</el-button>
            <el-button size="small" @click="restoreDefaultColumns">恢复默认</el-button>
            <el-button size="small" type="primary" @click="saveColumnsDialog">保存</el-button>
          </div>
        </el-dialog>

        <div class="pagination-container">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getDcopsCrossAuditList } from '@/api/appManage';
import { debounce } from 'lodash';
import * as XLSX from 'xlsx';

const JSON_COLS_ACTIVE = ['audit_info', 'ctrl_point_info', 'audit_result_info'];
const JSON_COLS_PASSIVE = ['audit_result_info', 'review_file'];

export default {
  name: 'DcopsCrossAudit',
  data() {
    const columnsActive = [
      { prop: 'opTicketid', label: '工单号', width: 150 },
      { prop: 'main_ticket_display', label: '待办工单号', width: 160 },
      { prop: 'scene', label: '场景', width: 100 },
      { prop: 'ticket_type', label: '工单类型', width: 180 },
      { prop: 'auditinfo_idcp_name', label: '机房', width: 140 },
      { prop: 'audit_result', label: '审计结果', width: 110 },
      { prop: 'audit_info', label: '审计内容', width: 160 },
      { prop: 'audit_result_info', label: '审计结果明细', width: 140 },
      { prop: 'audit_completer', label: '审计结单人', width: 120 },
      { prop: 'audit_complete_time', label: '审计完成时间', width: 140 },
      { prop: 'created_at', label: '创建时间', width: 170 },
      { prop: 'updated_at', label: '更新时间', width: 170 },
      { prop: 'ctrl_point_info', label: '管控点', width: 120 },
    ];
    const columnsPassive = [
      { prop: 'opTicketid', label: '工单号', width: 150 },
      { prop: 'main_ticket_display', label: '待办工单号', width: 160 },
      { prop: 'audit_result', label: '审计结果', width: 120 },
      { prop: 'audit_result_info', label: '审计结果明细', width: 140 },
      { prop: 'review_result', label: '复核结果', width: 120 },
      { prop: 'review_memo', label: '复核备注', width: 200 },
      { prop: 'review_file', label: '复核附件', width: 120 },
      { prop: 'finalResult', label: '最终结果', width: 120 },
      { prop: 'finalMemo', label: '最终说明', width: 180 },
      { prop: 'audit_result_idcp_name', label: '审计机房', width: 140 },
      { prop: 'review_completer', label: '复核结单人', width: 120 },
      { prop: 'created_at', label: '创建时间', width: 170 },
      { prop: 'updated_at', label: '更新时间', width: 170 },
    ];
    const defActive = columnsActive.map((c) => c.prop);
    const defPassive = columnsPassive.map((c) => c.prop);
    return {
      debouncedExport: null,
      loading: false,
      exportLoading: false,
      rows: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      showColumnsDialog: false,
      columnsActive,
      columnsPassive,
      defaultSelectedActive: defActive,
      defaultSelectedPassive: defPassive,
      selectedColumns: [...defActive],
      visibleColumns: [],
      /** 当前 TAB：active=主动 IDC_CROSS_AUDIT_ACTIVE，passive=被动 IDC_CROSS_AUDIT_PASSIVE */
      activeAuditTab: 'active',
      searchFormActive: {
        createdRange: [],
        op_ticketid: '',
        main_ticket_id: '',
        audit_result: '',
        scene: '',
        ticket_type: '',
        auditinfo_idcp_name: '',
        process_status: '',
      },
      searchFormPassive: {
        createdRange: [],
        op_ticketid: '',
        main_ticket_id: '',
        audit_result: '',
        review_result: '',
        final_result: '',
        audit_result_idcp_name: '',
        process_status: '',
      },
      jsonDetailVisible: false,
      jsonDetailTitle: '',
      jsonDetailMode: 'raw',
      jsonDetailRows: [],
      jsonDetailRawText: '',
    };
  },
  computed: {
    columns() {
      return this.activeAuditTab === 'active' ? this.columnsActive : this.columnsPassive;
    },
    tableTitle() {
      return this.activeAuditTab === 'active' ? '主动交叉审计列表' : '被动交叉审计列表';
    },
    exportButtonText() {
      return '导出全部';
    },
  },
  created() {
    this.refreshVisibleColumns();
    this.debouncedExport = debounce(this.handleExport, 300);
    this.fetchData();
  },
  methods: {
    jsonColsForSide() {
      return this.activeAuditTab === 'active' ? JSON_COLS_ACTIVE : JSON_COLS_PASSIVE;
    },
    isJsonColumn(prop) {
      return this.jsonColsForSide().includes(prop);
    },
    formatJson(val) {
      if (val === null || val === undefined || val === '') return '-';
      if (typeof val === 'string') return val;
      try {
        return JSON.stringify(val);
      } catch (e) {
        return String(val);
      }
    },
    parseJsonField(val) {
      if (val === null || val === undefined || val === '') return null;
      if (typeof val === 'object') return val;
      if (typeof val === 'string') {
        try {
          return JSON.parse(val);
        } catch (e) {
          return val;
        }
      }
      return val;
    },
    normalizeToRows(parsed) {
      if (parsed === null || parsed === undefined) return [];
      if (Array.isArray(parsed)) return parsed;
      if (typeof parsed === 'object') return [parsed];
      return [];
    },
    collectMainTicketIdsFromJson(jsonVal) {
      const p = this.parseJsonField(jsonVal);
      if (!p) return [];
      const rows = this.normalizeToRows(p);
      const ids = [];
      rows.forEach((r) => {
        if (!r || typeof r !== 'object') return;
        const id = r.mainTicketId || r.main_ticket_id;
        if (id != null && String(id).trim() !== '') {
          const s = String(id).trim();
          if (!ids.includes(s)) ids.push(s);
        }
      });
      return ids;
    },
    /** 列表展示：优先库表主单号列，其次 audit_info / audit_result_info 中 mainTicketId */
    mainTicketDisplay(row) {
      if (!row) return '-';
      if (this.activeAuditTab === 'active') {
        if (row.auditinfo_main_ticket_id && String(row.auditinfo_main_ticket_id).trim()) {
          return String(row.auditinfo_main_ticket_id).trim();
        }
        let ids = this.collectMainTicketIdsFromJson(row.audit_info);
        if (!ids.length) ids = this.collectMainTicketIdsFromJson(row.audit_result_info);
        return ids.length ? ids.join('，') : '-';
      }
      const ids = this.collectMainTicketIdsFromJson(row.audit_result_info);
      return ids.length ? ids.join('，') : '-';
    },
    normalizeAuditInfoRow(r) {
      if (!r || typeof r !== 'object') return {};
      return {
        mainTicketId: r.mainTicketId || r.main_ticket_id || '',
        idcpName: r.idcpName || r.idcp_name || '',
        completer: r.completer || '',
        ticketURL: r.ticketURL || r.ticket_url || '',
        auditService: r.auditService || r.audit_service || '',
        auditedService: r.auditedService || r.audited_service || '',
        memo: r.memo || '',
        ticketType: r.ticketType || r.ticket_type || '',
      };
    },
    normalizeCtrlPointRow(r) {
      if (!r || typeof r !== 'object') return {};
      return {
        ctrlContent: r.ctrlContent || r.ctrl_content || '',
        ctrlStandard: r.ctrlStandard || r.ctrl_standard || '',
      };
    },
    normalizeAuditResultRow(r) {
      if (!r || typeof r !== 'object') return {};
      return {
        mainTicketId: r.mainTicketId || r.main_ticket_id || '',
        scene: r.scene || '',
        ticketType: r.ticketType || r.ticket_type || '',
        ticketURL: r.ticketURL || r.ticket_url || '',
        ctrlStandard: r.ctrlStandard || r.ctrl_standard || '',
        ctrlContent: r.ctrlContent || r.ctrl_content || '',
        ctrlAuditResult: r.ctrlAuditResult || r.ctrl_audit_result || '',
        ctrlAuditMemo: r.ctrlAuditMemo || r.ctrl_audit_memo || '',
      };
    },
    jsonDialogTitleForProp(prop) {
      const map = {
        audit_info: '审计内容（auditInfo）',
        ctrl_point_info: '管控点内容（ctrlPointInfo）',
        audit_result_info: '审计结果明细（auditResultInfo）',
        review_file: '复核附件（reviewFile）',
      };
      return map[prop] || '详情';
    },
    jsonCellSummary(val, prop) {
      const parsed = this.parseJsonField(val);
      if (parsed === null || parsed === '' || parsed === undefined) return '-';
      const rows = this.normalizeToRows(parsed);
      if (!rows.length) return '-';
      if (prop === 'review_file') return `共 ${rows.length} 个附件`;
      return `共 ${rows.length} 条`;
    },
    openJsonDetail(row, prop) {
      const raw = row[prop];
      this.jsonDetailTitle = this.jsonDialogTitleForProp(prop);
      const parsed = this.parseJsonField(raw);
      if (parsed === null || parsed === undefined || parsed === '') {
        this.jsonDetailMode = 'raw';
        this.jsonDetailRawText = '(空)';
        this.jsonDetailRows = [];
        this.jsonDetailVisible = true;
        return;
      }
      if (typeof parsed !== 'object') {
        this.jsonDetailMode = 'raw';
        this.jsonDetailRawText =
          typeof parsed === 'string' ? parsed : JSON.stringify(parsed, null, 2);
        this.jsonDetailRows = [];
        this.jsonDetailVisible = true;
        return;
      }
      const rows = this.normalizeToRows(parsed);
      if (prop === 'review_file') {
        this.jsonDetailMode = 'review_file';
        this.jsonDetailRows = rows;
        this.jsonDetailRawText = '';
        this.jsonDetailVisible = true;
        return;
      }
      if (prop === 'audit_info') {
        this.jsonDetailMode = 'audit_info';
        this.jsonDetailRows = rows.map((r) => this.normalizeAuditInfoRow(r));
        this.jsonDetailVisible = true;
        return;
      }
      if (prop === 'ctrl_point_info') {
        this.jsonDetailMode = 'ctrl_point_info';
        this.jsonDetailRows = rows.map((r) => this.normalizeCtrlPointRow(r));
        this.jsonDetailVisible = true;
        return;
      }
      if (prop === 'audit_result_info') {
        this.jsonDetailMode = 'audit_result_info';
        this.jsonDetailRows = rows.map((r) => this.normalizeAuditResultRow(r));
        this.jsonDetailVisible = true;
        return;
      }
      this.jsonDetailMode = 'raw';
      try {
        this.jsonDetailRawText = JSON.stringify(parsed, null, 2);
      } catch (e) {
        this.jsonDetailRawText = String(parsed);
      }
      this.jsonDetailRows = [];
      this.jsonDetailVisible = true;
    },
    onJsonDetailClosed() {
      this.jsonDetailRows = [];
      this.jsonDetailRawText = '';
      this.jsonDetailMode = 'raw';
    },
    isImageUrl(url) {
      if (!url || typeof url !== 'string') return false;
      const base = url.split('?')[0].trim().toLowerCase();
      if (base.startsWith('data:image')) return true;
      return /\.(png|jpe?g|gif|webp|bmp|svg)$/.test(base);
    },
    fileUrl(f) {
      if (!f || typeof f !== 'object') return '';
      return f.fileURL || f.fileUrl || f.file_url || '';
    },
    fileDisplayName(f) {
      if (!f || typeof f !== 'object') return '附件';
      return f.fileName || f.file_name || this.fileUrl(f) || '附件';
    },
    onImgError(e) {
      if (e.target) e.target.style.display = 'none';
    },
    resultTagType(kind, text) {
      if (text === null || text === undefined || text === '') return 'info';
      const t = String(text).trim();
      if (kind === 'audit') {
        if (t === '通过') return 'success';
        if (t === '不通过') return 'danger';
        return 'info';
      }
      if (kind === 'ctrl') {
        if (t === '合格') return 'success';
        if (t === '不合格') return 'danger';
        if (t === '不涉及') return 'info';
        return 'warning';
      }
      if (kind === 'review') {
        if (t === '复核无误') return 'success';
        if (t === '申诉') return 'warning';
        return 'info';
      }
      if (kind === 'final') {
        if (/通过|无误|合格|成功/.test(t)) return 'success';
        if (/不通过|不合格|失败|驳回/.test(t)) return 'danger';
        if (/申诉|待复核/.test(t)) return 'warning';
        return 'info';
      }
      return 'info';
    },
    resultTagIcon(kind, text) {
      const ty = this.resultTagType(kind, text);
      if (ty === 'success') return 'el-icon-success';
      if (ty === 'danger') return 'el-icon-circle-close';
      if (ty === 'warning') return 'el-icon-warning';
      return 'el-icon-info';
    },
    formatTime(val) {
      if (!val) return '-';
      return this.$moment(val).format('YYYY-MM-DD HH:mm:ss');
    },
    cellText(val) {
      if (val === null || val === undefined || val === '') return '-';
      return val;
    },
    isEmptyCell(val) {
      return val === null || val === undefined || val === '';
    },
    /** 审计结果 / 最终结果是否视为未出结论（含纯空格） */
    isPendingAuditEmpty(val) {
      if (val === null || val === undefined) return true;
      return String(val).trim() === '';
    },
    dcopsDetailHref(opTicketid) {
      const id = opTicketid || '';
      return `https://dcops.fre.tencent-cloud.com/appManage/tickets/details?params=${encodeURIComponent(id)}`;
    },
    buildQuery(extra = {}) {
      const side = this.activeAuditTab;
      const sf = side === 'active' ? this.searchFormActive : this.searchFormPassive;
      const body = {
        audit_side: side,
        page: this.currentPage,
        size: this.pageSize,
        ...extra,
      };
      if (sf.op_ticketid) body.op_ticketid = sf.op_ticketid;
      if (sf.audit_result) body.audit_result = sf.audit_result;
      const range = sf.createdRange || [];
      if (range[0]) body.created_start = range[0];
      if (range[1]) body.created_end = range[1];
      if (sf.process_status === 'running' || sf.process_status === 'finished') {
        body.process_status = sf.process_status;
      }
      if (sf.main_ticket_id && String(sf.main_ticket_id).trim()) {
        body.main_ticket_id = String(sf.main_ticket_id).trim();
      }
      if (side === 'active') {
        if (sf.scene) body.scene = sf.scene;
        if (sf.ticket_type) body.ticket_type = sf.ticket_type;
        if (sf.auditinfo_idcp_name) body.auditinfo_idcp_name = sf.auditinfo_idcp_name;
      } else {
        if (sf.review_result) body.review_result = sf.review_result;
        if (sf.final_result) body.final_result = sf.final_result;
        if (sf.audit_result_idcp_name) body.audit_result_idcp_name = sf.audit_result_idcp_name;
      }
      return body;
    },
    onAuditTabClick(tab) {
      const name = tab.name;
      if (name !== 'active' && name !== 'passive') return;
      this.selectedColumns =
        name === 'active' ? [...this.defaultSelectedActive] : [...this.defaultSelectedPassive];
      this.refreshVisibleColumns();
      this.currentPage = 1;
      this.fetchData();
    },
    async fetchData() {
      this.loading = true;
      try {
        const res = await getDcopsCrossAuditList(this.buildQuery());
        const payload = res && res.data ? res.data : {};
        this.rows = payload.data || [];
        this.total = payload.total != null ? payload.total : 0;
        if (payload.code && payload.code !== 200) {
          this.$message.warning(payload.msg || '查询异常');
        }
      } catch (e) {
        console.error(e);
        this.$message.error('获取数据失败');
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.currentPage = 1;
      this.fetchData();
    },
    handleResetActive() {
      this.searchFormActive = {
        createdRange: [],
        op_ticketid: '',
        main_ticket_id: '',
        audit_result: '',
        scene: '',
        ticket_type: '',
        auditinfo_idcp_name: '',
        process_status: '',
      };
      this.currentPage = 1;
      this.fetchData();
    },
    handleResetPassive() {
      this.searchFormPassive = {
        createdRange: [],
        op_ticketid: '',
        main_ticket_id: '',
        audit_result: '',
        review_result: '',
        final_result: '',
        audit_result_idcp_name: '',
        process_status: '',
      };
      this.currentPage = 1;
      this.fetchData();
    },
    refreshVisibleColumns() {
      this.visibleColumns = this.columns.filter((c) => this.selectedColumns.includes(c.prop));
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },
    openColumnsDialog() {
      this.showColumnsDialog = true;
    },
    saveColumnsDialog() {
      this.showColumnsDialog = false;
      this.refreshVisibleColumns();
    },
    selectAllColumns() {
      this.selectedColumns = this.columns.map((c) => c.prop);
    },
    restoreDefaultColumns() {
      this.selectedColumns =
        this.activeAuditTab === 'active'
          ? [...this.defaultSelectedActive]
          : [...this.defaultSelectedPassive];
    },
    async handleExport() {
      if (this.exportLoading) return;
      this.exportLoading = true;
      this.loading = true;
      try {
        const res = await getDcopsCrossAuditList(
          this.buildQuery({
            export_excel: 1,
            page: 1,
            size: this.pageSize,
          }),
        );
        const payload = res && res.data ? res.data : {};
        const allData = payload.data || [];
        const cols = this.visibleColumns.length ? this.visibleColumns : this.columns;
        const worksheetData = allData.map((row) => {
          const rowData = {};
          cols.forEach((column) => {
            let value = row[column.prop];
            if (column.prop === 'main_ticket_display') {
              value = this.mainTicketDisplay(row);
            } else if (this.isJsonColumn(column.prop)) {
              value = this.formatJson(value);
            } else if (column.prop === 'created_at' || column.prop === 'updated_at') {
              value = this.formatTime(value);
            } else if (column.prop === 'audit_result' && this.isPendingAuditEmpty(value)) {
              value = '审计中...';
            } else if (column.prop === 'finalResult') {
              if (this.isPendingAuditEmpty(value)) {
                value = this.isPendingAuditEmpty(row.review_result) ? '' : '复核中';
              }
            }
            rowData[column.label] = value === '-' ? '' : value;
          });
          return rowData;
        });
        const worksheet = XLSX.utils.json_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();
        const sheetName = this.activeAuditTab === 'active' ? '主动交叉审计' : '被动交叉审计';
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName.slice(0, 31));
        const ts = this.$moment().format('YYYYMMDDHHmmss');
        XLSX.writeFile(workbook, `DCOPS交叉审计_${sheetName}_${ts}.xlsx`);
        this.$message.success('导出成功');
      } catch (e) {
        console.error(e);
        this.$message.error('导出失败');
      } finally {
        this.exportLoading = false;
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.audit-search-card ::v-deep .el-card__body {
  padding-bottom: 12px;
}

.audit-tabs ::v-deep .el-tabs__header {
  margin-bottom: 8px;
}

.audit-tabs ::v-deep .el-tabs__nav-wrap::after {
  height: 1px;
}

.container {
  padding: 20px;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}

.search-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.search-form {
  width: 100%;
}

/* 与 DCOPS 工单页一致：表单项对齐与间距 */
.search-form ::v-deep .el-form-item {
  margin-bottom: 18px;
  display: flex;
}

.search-actions-row {
  margin-top: 4px;
}

.search-button {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-left: 10px;
  padding-top: 4px;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
}

.box-card {
  margin-bottom: 20px;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
}

.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}

.checkbox-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 10px;
  max-height: 320px;
  overflow-y: auto;
}

.checkbox-item {
  margin-right: 0;
}

::v-deep .el-table a {
  color: #409eff;
  text-decoration: none;
  font-weight: 500;
}

::v-deep .el-table a:hover {
  color: #66b1ff;
  text-decoration: underline;
}

::v-deep .el-select,
.el-input {
  width: 100% !important;
}

::v-deep .el-form-item__content {
  width: calc(100% - 10px) !important;
}

/* 日期范围选择器宽度（与 serverMove 一致） */
::v-deep .el-date-editor.el-input__inner,
::v-deep .el-date-editor--daterange.el-input__inner {
  width: 100% !important;
}

::v-deep .el-range-editor.el-input__inner {
  width: 100% !important;
}

::v-deep .el-date-editor .el-range-input {
  width: 66% !important;
}

::v-deep .el-range-editor--small .el-range-input {
  font-size: 12px !important;
}

.json-cell-wrap {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.json-view-btn {
  padding: 0;
}

.json-cell-summary {
  color: #909399;
  font-size: 12px;
}

.result-ico {
  margin-right: 4px;
}

.json-detail-body {
  min-height: 80px;
}

.json-empty {
  color: #909399;
  padding: 24px;
  text-align: center;
}

.json-raw {
  margin: 0;
  padding: 12px;
  background: #f5f7fa;
  border-radius: 4px;
  font-size: 12px;
  line-height: 1.5;
  max-height: 520px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-all;
}

.review-file-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.review-file-item {
  padding: 12px 0;
  border-bottom: 1px solid #ebeef5;
}

.review-file-item:last-child {
  border-bottom: none;
}

.el-file-icon {
  margin-right: 8px;
  color: #409eff;
  font-size: 18px;
  vertical-align: middle;
}

.file-name {
  vertical-align: middle;
}

.img-preview-wrap {
  margin-top: 10px;
}

.img-preview-wrap .thumb {
  max-width: 100%;
  max-height: 240px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}

.audit-pending {
  color: #e6a23c;
  font-size: 13px;
}
</style>
